export default {"src":"/_next/static/media/affirm-logo.719dff37.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};